import { withApollo } from "react-apollo";
import React from "react";
import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";
import { updateRoleQuery } from "../../../services/graphql/queries/roles";
import { getListofStatusQuery } from "../../../services/graphql/queries/product";
import DisplayErrors from "../../Common/DisplayErrors";
import ReactModal from "../../Common/ReactModal";
import { getRoleStatus } from "../../Common/ListOfStatus";
import { alphanumericAcceptanceValidation } from "../../../miscellaneous/misc";
import {
  UNDERSCORE,
  ALPHANUMERIC_NAME_VALIDATION
} from "../../../constants/app-constants";

class RolesEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Id: "",
      roleName: "",
      roleNameErr: false,
      description: "",
      descriptionErr: false,
      status: "",
      listOfStatus: [],
      errors: [],
      isSubmitDisable: false,
      reactModalVisible: false,
      requireCancel: false,
      modalMessage: "Updated Successfully",
      entityType: "",
      entityTypeErr: false
    };

    this.resetForm = this.resetForm.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }

  componentDidMount() {
    this.setState({ ...this.props.user });
    this.initialState = this.state;

    this.props.client
      .query({
        query: getListofStatusQuery,
        variables: { statusFor: "9" },
        fetchPolicy: "network-only"
      })
      .then(result => {
        this.setState({
          listOfStatus: result.data.getListofStatus
        });
      })
      .catch(error => {
        this.setState({ isSubmitDisable: false });
        error.graphQLErrors.map(({ message }, i) => {
          this.setState(prevState => {
            return { errors: [message] };
          });
        });
      });
  }

  resetForm() {
    this.setState({
      errors: [],
      roleNameErr: false,
      descriptionErr: false
    });
    // this.setState({ ...this.initialState });
    this.setState({ ...this.props.user });
    this.initialState = this.state;
  }

  submitForm(e) {
    //Use below variables to Update DB via GraphQL after all validations pass
    const { Id, roleName, description, status, entityType } = this.state;
    var that = this;
    this.setState({ errors: [] });

    e.preventDefault();

    if (roleName == "") {
      this.state.roleNameErr = "* Valid Input for Role Name are A-Z, 0-9 and _";
    } else if (!alphanumericAcceptanceValidation(roleName, UNDERSCORE)) {
      this.state.roleNameErr =
        "* Role Name must start with a character and can contain alphanumeric and _  ";
    } else if (roleName.length < 5) {
      this.state.roleNameErr = "* Role Name must be minimum 5 characters";
    } else {
      this.state.roleNameErr = "";
    }

    if (description == "") {
      this.state.descriptionErr = "*Enter Valid description";
    } else if (
      !alphanumericAcceptanceValidation(
        description,
        ALPHANUMERIC_NAME_VALIDATION
      )
    ) {
      this.state.descriptionErr =
        "Description must start with a character and can contain alphanumeric and &, _, / ";
    } else {
      this.state.descriptionErr = "";
    }
    if (entityType == "") {
      this.state.entityTypeErr = "*Enter select a valid Entity type";
    } else {
      this.state.entityTypeErr = "";
    }
    this.setState({});
    if (
      this.state.roleNameErr != "" ||
      this.state.descriptionErr != "" ||
      this.state.entityTypeErr != ""
    ) {
      return;
    }

    this.setState({ loading: true, isSubmitDisable: true });
    this.props.client
      .mutate({
        mutation: updateRoleQuery,
        variables: {
          id: this.state.Id,
          roleName: this.state.roleName,
          description: this.state.description,
          status: this.state.status,
          entityType: parseInt(this.state.entityType)
        },
        fetchPolicy: "no-cache"
      })
      .then(result => {
        that.setState({ isSubmitDisable: false, reactModalVisible: true });
      })
      .catch(error => {
        console.log("~~~error: ", error);
        that.setState({ isSubmitDisable: false });
        error.graphQLErrors.map(({ message }, i) => {
          that.setState(prevState => {
            return { errors: [message] };
          });
        });
        setTimeout(() => {
          that.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  }

  submitModal() {
    this.setState({ reactModalVisible: false });
    this.props.onUpdateUser(this.state);
    this.props.toggleEditMode(false);
  }

  render() {
    const {
      Id,
      roleName,
      roleNameErr,
      description,
      descriptionErr,
      status,
      listOfStatus,
      errors,
      isSubmitDisable,
      reactModalVisible,
      requireCancel,
      modalMessage,
      entityType,
      entityTypeErr
    } = this.state;
    let StatusList = getRoleStatus(this.props.user.status);
    return (
      <>
        <ReactModal
          reactModalVisible={reactModalVisible}
          submitModal={this.submitModal}
          modalMessage={modalMessage}
          requireCancel={requireCancel}
        />
        <div className="row">
          <div className="col-md-11">
            <h1 className="heading m-b-25">Role Details</h1>
            <div
              className="row"
              style={{
                display: errors.length === 0 ? "none" : "block"
              }}
            >
              <div className="col-md-6">
                <div className="alert alert-success" role="alert">
                  <div className="row">
                    <DisplayErrors errors={errors} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6" />
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>ROLE NAME</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                    <input
                      type="text"
                      className={
                        "form-control " + (roleNameErr ? "is-invalid" : "")
                      }
                      placeholder="Enter Name"
                      value={roleName}
                      maxLength={20}
                      onChange={e => {
                        this.setState({ roleName: e.target.value });
                      }}
                    />
                    {roleNameErr ? (
                      <div className="invalid-feedback">
                        {this.state.roleNameErr}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>DESCRIPTION</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>
                    <input
                      type="text"
                      className={
                        "form-control " + (descriptionErr ? "is-invalid" : "")
                      }
                      placeholder="Enter Reference Code"
                      value={description}
                      maxLength={40}
                      onChange={e => {
                        this.setState({
                          description: e.target.value
                        });
                      }}
                    />
                    {descriptionErr ? (
                      <div className="invalid-feedback">
                        {this.state.descriptionErr}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="form-group">
                    <label>Status</label>
                    <select
                      className="form-control light-green select-style-1"
                      value={status}
                      onChange={e => {
                        this.setState({ status: parseInt(e.target.value) });
                      }}
                    >
                      {StatusList.length
                        ? StatusList.map((data, index) => {
                            return (
                              <option key={index} value={data.id}>
                                {data.name}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>ENTITY TYPE</label>
                    <span style={{ color: "#ff0000", fontSize: "16px" }}>
                      *
                    </span>

                    <select
                      className="form-control light-green select-style-1"
                      value={entityType}
                      onChange={e => {
                        this.setState({ entityType: e.target.value });
                      }}
                    >
                      {/* <option value={""}>Select</option> */}
                      <option value={1}> Investor </option>
                      <option value={2}> User</option>
                      {/* <option value={3}>Installing Company</option>
                      <option value={4}>Installer</option> */}
                      {/* <option value={5}>Customer</option> */}
                    </select>
                    {entityTypeErr ? (
                      <div
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {entityTypeErr}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={e => this.submitForm(e)}
                    disabled={isSubmitDisable}
                  >
                    Submit
                  </button>
                </div>

                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-light m-l-50"
                    onClick={this.resetForm}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </>
    );
  }
}

export default withApollo(RolesEdit);
